import { createContext, useContext, type FC, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import type { CallPopUpDefaultStore } from 'widgets/CallPopUp/store/callPopUpDefaultStore'

export const CallPopUpDefaultContext = createContext<CallPopUpDefaultStore | null>(null)

export function useCallPopUpDefaultContext() {
  const context = useContext(CallPopUpDefaultContext)
  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with CallPopUpDefaultStoreProvider'
    )
  }
  return context
}

type IProviderCallPopUpDefaultProps = {
  children: ReactNode
  value: CallPopUpDefaultStore
}

export const ProviderCallPopUpDefault: FC<IProviderCallPopUpDefaultProps> = observer(
  ({ children, value }) => {
    return (
      <CallPopUpDefaultContext.Provider value={value}>{children}</CallPopUpDefaultContext.Provider>
    )
  }
)
